module.exports = __webpack_public_path__ + "media/images/home-employees-fd4576d627e9e74238c6fbc6a2b35112.png";